import React, { useState } from 'react';
import { createStream } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';

const CreateStreamModal = ({ onClose, onStreamCreated }) => {
    const [name, setName] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!name) {
            setError('Please fill in all fields.');
            return;
        }

        try {
            await createStream({
                name: name,
            });
            onStreamCreated();
            onClose();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>X</button>
                <h2>Create New Stream</h2>
                {error && <p className="error">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            id="name"
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder='Name'
                        />
                    </div>
                    <div className='actions-centered'>
                        <button type="submit" className="submit-button text-button">Create</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateStreamModal;